"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useOnClickOutside = exports.default = void 0;
var _react = require("react");
var _isFunction = require("./isFunction");
const useOnClickOutside = ({
  ref,
  handleClickOutside,
  show = true
}) => {
  const handleMouseDown = e => {
    var _a, _b;
    if (!ref.current || ((_b = (_a = ref.current).contains) === null || _b === void 0 ? void 0 : _b.call(_a, e.target))) {
      return;
    }
    if ((0, _isFunction.isFunction)(handleClickOutside)) {
      handleClickOutside(e);
    }
  };
  (0, _react.useEffect)(() => {
    if (show) {
      document.addEventListener('mousedown', handleMouseDown);
    } else {
      document.removeEventListener('mousedown', handleMouseDown);
    }
    return () => {
      document.removeEventListener('mousedown', handleMouseDown);
    };
  }, [show]);
};
exports.useOnClickOutside = useOnClickOutside;
var _default = exports.default = useOnClickOutside;